import { useSelector } from "react-redux";
import Header from "../../../../containers/Header";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import { modalsData } from "../../../../lib/data/promotions.data";
import BackIcon from "../../../../assets/svg/BackIcon";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import DepositBonus2 from "../../../../assets/images/banner/promotions/welcomeBonus.jpeg";
import DepositBonus1 from "../../../../assets/images/banner/promotions/welcomeBonusonCasino.jpeg";
import DepositBonus3 from "../../../../assets/images/banner/promotions/weeklybonus.jpeg";
import DepositBonus4 from "../../../../assets/images/banner/promotions/weeklycashback.jpeg";
import DepositBonus5 from "../../../../assets/images/banner/promotions/netwallet.jpeg";
import BonusModal from "../../../../containers/BonusModal";

const modalsId = [
  {
    id: 1,
    image: DepositBonus1,
    altText: "Welcome Bonus On Casino",
    name: "Welcome Bonus On Casino",
  },
  {
    id: 2,
    image: DepositBonus2,
    altText: "First Deposit Bouns",
    name: "First Deposit Bouns",
  },
  {
    id: 3,
    image: DepositBonus3,
    altText: "Weekly Sports Cashback Bouns",
    name: "Weekly Sports Cashback Bouns",
  },
  {
    id: 4,
    image: DepositBonus4,
    altText: "Weekly Cashback On Casino/Live Casino/Slots",
    name: "Weekly Cashback On Casino/Live Casino/Slots",
  },
  {
    id: 5,
    image: DepositBonus5,
    altText: "5% on Netwallet Deposit",
    name: "5% on Netwallet Deposit",
  },
];

const Promotions = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const [selectedModal, setSelectedModal] = useState(null);

  const handleShow = (modalId) => {
    const modalData = modalsData.find((modal) => modal.id === modalId);
    setSelectedModal(modalData);
  };

  const handleClose = () => setSelectedModal(null);
  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main">
        <Container>
          <div className="pagesHeading">
            <h2 className="sectionTitle border-0">Promotions</h2>
            <a className="back-link" href="/">
              Back <BackIcon />
            </a>
          </div>

          {/* <h4 className="m-5">Coming Soon</h4> */}
          <div className="promotionsBanners">
            <ul className="promo-grid">
              {modalsId.map((item) => (
                <li key={item.id} className="promo-card">
                  <Button onClick={() => handleShow(item.id)}>
                    <div className="img-wrapper">
                      <img src={item.image} alt={item.altText} />
                    </div>
                    <div className="promo-title">{item.name}</div>
                  </Button>
                </li>
              ))}
            </ul>
          </div>

          <BonusModal
            data={selectedModal}
            show={!!selectedModal}
            handleClose={handleClose}
          />
        </Container>
      </main>

      {isAuth ? <Footer /> : <BeforeLoginFooter />}
    </>
  );
};

export default Promotions;
